<div class="flex flex-column gap-3">

    <ng-container *ngIf="!hasData; else dataTpl">
        <p-card>
            <div class="flex align-items-center gap-2 text-color-secondary">
                <i class="pi pi-info-circle"></i>
                <span>Todavía no hay datos disponibles para esta videoperitación.</span>
            </div>
        </p-card>
    </ng-container>

    <ng-template #dataTpl>
        <!-- Información general -->
        <p-card header="Información general">
            <div class="grid">
                <div class="col-12 md:col-6" *ngFor="let item of generalInfo">
                    <div class="input-field">
                        <label class="text-bold">{{ item.label }}</label>
                        <div>{{ item.value }}</div>
                    </div>
                </div>
            </div>
        </p-card>

        <!-- Secciones -->
        <ng-container *ngFor="let node of nodes">
            <p-card *ngIf="node.rootFields?.length" [header]="node.nodeLabel">
                <div class="grid">
                    <div class="col-12 md:col-6" *ngFor="let field of node.rootFields">
                        <div class="input-field">
                            <label class="text-bold">{{ field.label }}</label>
                            <ng-container *ngIf="isCollected(field); else missingTpl">
                                <div class="font-medium">{{ displayValue(getFieldValue(field.key)) }}</div>
                            </ng-container>
                            <ng-template #missingTpl>
                                <div class="text-color-secondary font-italic">
                                    {{ statusLabel(field).text }}
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </p-card>
        </ng-container>
    </ng-template>

    <div class="flex justify-content-end">
        <p-button label="Cerrar" icon="pi pi-times" [text]="true" (click)="close()"></p-button>
    </div>
</div>
